import { useEffect } from 'react'
import { toast } from '@dd3tech/wiggui/Toast'
import {
  generatePdf,
  validateDescription,
  generateExternalPdf
} from '../services'
import { openPDFFromUrl } from '../../utils'
import { useModalDescriptionTooLongStore } from '../store'
import { IPropertyDetail } from '../../interfaces/src'

export const usePDFDropdown = (
  property: IPropertyDetail,
  setIsLoadingPdf: (val: boolean) => void,
  secondaryAction: (arg: string) => void
) => {
  const [
    setIsOpen,
    setPropertyId,
    setPrimaryAction,
    setSecondaryAction,
    setIsLoading
  ] = useModalDescriptionTooLongStore((state) => [
    state?.setIsOpen,
    state?.setPropertyId,
    state?.setPrimaryAction,
    state?.setSecondaryAction,
    state?.setIsLoading
  ])

  const onGenerateOriginalPdf = async () => {
    setIsLoadingPdf(true)
    const { isSuccess, data } = await validateDescription({
      propertyId: property?.propertyId
    })

    if (isSuccess && data?.isValid) {
      generatePDF()
    } else {
      setIsLoadingPdf(false)
      setIsLoading(false)
      setIsOpen(true)
    }
  }

  const handleStatus = () => {
    setIsLoadingPdf(false)
    setIsOpen(false)
  }

  const onGenerateOriginalExternalPdf = async (
    withAsesorInformation: boolean
  ) => {
    setIsLoadingPdf(true)
    const reponse = await generateExternalPdf({
      propertyId: property?.propertyId,
      asesorInformation: withAsesorInformation
    })

    if (reponse.isSuccess && reponse.data) {
      try {
        await openPDFFromUrl(
          reponse.data.url,
          reponse.data.pdfName,
          handleStatus
        )
      } catch {
        setIsLoadingPdf(false)
        setIsOpen(false)
      }
    } else {
      setIsLoadingPdf(false)
    }
  }

  const generatePDF = async () => {
    const reponse = await generatePdf({
      propertyId: property?.propertyId
    })

    if (reponse.isSuccess && reponse.data) {
      try {
        await openPDFFromUrl(
          reponse.data.url,
          reponse.data.pdfName,
          handleStatus
        )
        toast({
          title: 'El PDF se ha generado y descargado correctamente.',
          type: 'success'
        })
      } catch {
        handleStatus()
        toast({
          title: 'No se pudo descargar el PDF. Intenta de nuevo.',
          type: 'error'
        })
      }
    } else {
      handleStatus()
    }
  }

  useEffect(() => {
    setPropertyId(property?.propertyId)
    setPrimaryAction(() => {
      setIsLoadingPdf(true)
      setIsLoading(true)
      generatePDF()
    })
    setSecondaryAction(secondaryAction)
  }, [])

  return {
    onGenerateOriginalPdf,
    onGenerateOriginalExternalPdf,
    setOpenModalTooLongDesc: setIsOpen
  }
}
export default usePDFDropdown
